import { lazy, Suspense } from 'react'
import type { ReactNode } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { AppLayout } from './layout/AppLayout'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { NotFoundPage } from './pages/NotFoundPage'

/*
 * Las pantallas pesadas se cargan por demanda. Reportes arrastra la librería
 * de gráficos, que triplicaba el bundle inicial de un panel donde la mayoría
 * entra a ver la jornada del día y nada más.
 */
const EmployeesPage = lazy(() =>
  import('./pages/EmployeesPage').then((m) => ({ default: m.EmployeesPage })),
)
const BranchesPage = lazy(() =>
  import('./pages/BranchesPage').then((m) => ({ default: m.BranchesPage })),
)
const DevicesPage = lazy(() =>
  import('./pages/DevicesPage').then((m) => ({ default: m.DevicesPage })),
)
const LeavesPage = lazy(() =>
  import('./pages/LeavesPage').then((m) => ({ default: m.LeavesPage })),
)
const ReportsPage = lazy(() =>
  import('./pages/ReportsPage').then((m) => ({ default: m.ReportsPage })),
)
const AuditPage = lazy(() =>
  import('./pages/AuditPage').then((m) => ({ default: m.AuditPage })),
)

function Lazy({ children }: { children: ReactNode }) {
  return (
    <Suspense
      fallback={
        <Box sx={{ display: 'grid', placeItems: 'center', minHeight: 320 }}>
          <CircularProgress />
        </Box>
      }
    >
      {children}
    </Suspense>
  )
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'empleados', element: <Lazy><EmployeesPage /></Lazy> },
          { path: 'sucursales', element: <Lazy><BranchesPage /></Lazy> },
          { path: 'dispositivos', element: <Lazy><DevicesPage /></Lazy> },
          { path: 'licencias', element: <Lazy><LeavesPage /></Lazy> },
          { path: 'reportes', element: <Lazy><ReportsPage /></Lazy> },
          { path: 'auditoria', element: <Lazy><AuditPage /></Lazy> },
          { path: '404', element: <NotFoundPage /> },
          { path: '*', element: <Navigate to="/404" replace /> },
        ],
      },
    ],
  },
])
